<template>
  <List :slots="slots" :dots="true">
    <Paragraph
      v-for="(point, index) in data.points.left"
      :key="index"
      :slot="`slot-${index}`"
      size="normal"
      :text="point.text"
      data-anim="text"
      data-view="false"
    />
  </List>
</template>

<script>
import List from '@/components/text/List.vue';
import Paragraph from '@/components/text/Paragraph.vue';

export default {
  name: 'BulletList',

  components: {
    List,
    Paragraph,
  },

  props: {
    data: {
      type: Object,
      required: true,
    },
  },

  computed: {
    slots() {
      const s = [];
      this.data.points.left.forEach((p, index) => s.push(`slot-${index}`));
      return s;
    },
  },
};
</script>

<style>

</style>
